import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import IndexCard from "../../../shared/IndexCard/IndexCard";
import { Link, useOutletContext } from "react-router-dom";
import PaginatedListLayout from "../../../../shared/pagination/PaginatedListLayout";
import FloatingMeetingButton from "../../../shared/buttons/FloatingMeetingButton";

const JobListPage = () => {
  const {
    jobExists,
    isActive,
    jobs,
    loading,
    hasSearchFilters,
    handleMarkedRead,
    hasExecutedSearch,
    isSearching,
    pagination,
    goToPage,
  } = useOutletContext();

  // テーマ情報とレスポンシブ判定
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const openJobs = jobs;

  // 検索に一致する結果がない場合のメッセージ
  const shouldShowNoResultsMessage =
    hasExecutedSearch && hasSearchFilters && !isSearching;

  const emptyText = shouldShowNoResultsMessage
    ? "検索条件と一致する結果が見つかりません。"
    : [
        "希望条件を公開中にしていただくことで、運営局があなたの条件を確認できるようになります。",
        "運営局にてご希望に沿った転職先をお探しし、条件に合う求人が見つかり次第ご紹介いたします。",
        "転職先の紹介を希望される方は、希望条件を公開中でお待ちください。",
      ].join("\n");

  // loading中やデータが0件のときは map を実行しない
  const shouldRenderJobs = !loading && openJobs.length > 0;

  return (
    <Box sx={{ maxWidth: 960, mx: "auto" }}>
      <PaginatedListLayout
        items={openJobs}
        loading={loading}
        pagination={pagination}
        onPageChange={goToPage}
        emptyText={emptyText}
      >
        {shouldRenderJobs && (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
              gap: { xs: 1, sm: 2 },
            }}
          >
            {openJobs.map((job) => (
              <IndexCard
                key={job.id}
                item={job}
                type="job"
                component={Link}
                to={`/jobs/${job.id}`} // ユーザー向け詳細ページへ
                onMarkedRead={handleMarkedRead}
                contractExists={jobExists}
                isActive={isActive}
              />
            ))}
          </Box>
        )}
      </PaginatedListLayout>

      {/* WEB面談を申し込むボタン */}
      <FloatingMeetingButton isMobile={isMobile} type="job" />
    </Box>
  );
};

export default JobListPage;
